export enum VerifyTypeEnum {
  NOT_VERIFIED = 'notVerified',
  OFFICIAL_VERIFIED = 'verifiedByOfficial',
  OFFICIAL_REJECTED = 'rejectedByOfficial',
  SELF_VERIFIED = 'selfVerified',
}
